import { getApiRoot } from "./config";
import { getNoContentResponse } from "./jsonResponse";

export const passwordUpdatePut = (
  password: string,
  userKey: string,
  accessToken: string,
  tokenType: string,
) =>
  fetch(`${getApiRoot()}/user/${userKey}/password`, {
    method: "PUT",
    body: JSON.stringify({
      password,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `${tokenType} ${accessToken}`,
    },
  }).then(getNoContentResponse);
